export * from './directory.service';
import { DirectoryService } from './directory.service';
export const APIS = [DirectoryService];
